/* The Bean Archives V5 — Subscribe page buy-box.
   Self-contained (own hooks; does not touch site.js's [data-lean] demo).
   Plan + lean pickers, media gallery, and the ship/renewal "system". */
(() => {
  "use strict";

  /* ======================================================================
     EDIT EACH CYCLE — the single source of truth for the buy box.
     Keep in sync with the homepage hero ("Now signing up for Volume N").
     ====================================================================== */
  const SUB = {
    volume: 25,                 // volume shown in "Inside Volume N" (the November lineup on display)
    nextVolume: 26,             // what the first renewal pays for (December box)
    orderBy: "2026-12-17",      // (unused — countdown pill removed; kept for when a cutoff returns)
    ship: "November 15",        // when the first box ships
    firstRenewal: "November 28", // first monthly renewal date
    prices: { six: 58, four: 44 },
    currency: "$",
  };

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = (n) => `${SUB.currency}${n}`;

  /* ---- State ---------------------------------------------------------- */
  const state = { plan: "six", lean: "mixed" };

  const leanCopy = {
    clean: "You're getting the 4 cleanest of the six. Usually 2–3 of these will be washed.",
    mixed: "You love variety and just want four bags instead of six.",
    funky: "You're getting the 4 funkiest of the six. Expect 1–2 really funky ones. Occasionally you'll get a washed.",
  };

  /* ---- Elements ------------------------------------------------------- */
  const priceEls  = $$("[data-price]");   // buy-box head + sticky mobile bar
  const ctaEl     = $("[data-cta]");
  const leanWrap  = $("[data-leanwrap]");
  const readout   = $(".lean-readout");
  const planNote  = $("[data-plannote]");
  const buyForm   = $("[data-buyform]");    // the /cart/add product form
  const idInput   = $("[data-id-input]");   // hidden variant id (size + lean)

  /* ---- Plan + lean rendering ----------------------------------------- */
  const render = () => {
    const isFour = state.plan === "four";
    const price = isFour ? SUB.prices.four : SUB.prices.six;

    $$(".opt[data-plan]").forEach((o) =>
      o.setAttribute("aria-checked", String(o.dataset.plan === state.plan)));

    priceEls.forEach((el) => (el.innerHTML =
      `<b>${money(price)}</b><span class="per">/ month</span>`));
    if (ctaEl) ctaEl.textContent = "Subscribe";

    if (leanWrap) leanWrap.classList.toggle("is-on", isFour);
    if (planNote) {
      planNote.hidden = !isFour;
      planNote.innerHTML = isFour
        ? `You're getting four of the month's six. Perfect if you want less or want to stay closer to one side of the clean/funky spectrum.`
        : ``;
    }

    if (isFour && readout) readout.innerHTML = leanCopy[state.lean];

    // drive the product form: pick the matching variant (6-bag, or the 4-bag for the chosen lean)
    if (idInput && buyForm) {
      idInput.value = isFour ? (buyForm.dataset[state.lean] || buyForm.dataset.mixed) : buyForm.dataset.six;
    }
  };

  $$(".opt[data-plan]").forEach((o) =>
    o.addEventListener("click", () => { state.plan = o.dataset.plan; render(); }));

  $$(".leanpick button").forEach((b) =>
    b.addEventListener("click", () => {
      state.lean = b.dataset.lean;
      $$(".leanpick button").forEach((x) =>
        x.setAttribute("aria-pressed", String(x.dataset.lean === state.lean)));
      if (readout) readout.innerHTML = leanCopy[state.lean];
      if (state.plan === "four" && idInput && buyForm) idInput.value = buyForm.dataset[state.lean] || buyForm.dataset.mixed;
    }));

  /* ---- Media gallery -------------------------------------------------- */
  const mainImg = $("[data-gallery-main] img");
  $$(".thumb").forEach((t) =>
    t.addEventListener("click", () => {
      const img = t.querySelector("img");
      if (mainImg && img) {
        mainImg.src = img.dataset.full || img.src;
        mainImg.alt = img.alt;
      }
      $$(".thumb").forEach((x) => x.setAttribute("aria-current", String(x === t)));
    }));

  /* ---- Ship / renewal system ----------------------------------------- */
  $$("[data-vol]").forEach((el) => (el.textContent = `Volume ${SUB.volume}`));
  $$("[data-nextvol]").forEach((el) => (el.textContent = `Volume ${SUB.nextVolume}`));
  $$("[data-ship]").forEach((el) => (el.textContent = SUB.ship));
  $$("[data-renewal]").forEach((el) => (el.textContent = SUB.firstRenewal));

  // live "days left to order" countdown — only shows when in the future
  const cd = $("[data-countdown]");
  if (cd) {
    const due = new Date(SUB.orderBy + "T23:59:59");
    const days = Math.ceil((due - new Date()) / 86400000);
    const orderByLabel = due.toLocaleDateString("en-US", { month: "short", day: "numeric" });
    if (days > 0) {
      cd.innerHTML = `<span class="live"></span> ${days} day${days === 1 ? "" : "s"} left to start with Volume ${SUB.volume}`;
      cd.hidden = false;
    } else {
      cd.hidden = true;
    }
    $$("[data-orderby]").forEach((el) => (el.textContent = orderByLabel));
  }

  /* ---- Cart submit guard ---------------------------------------------- */
  // The buy-box is a real product form (action=/cart/add). Block submit only
  // if the subscription product/variant isn't wired yet (draft/unset), so we
  // never POST an empty variant id.
  if (buyForm) {
    buyForm.addEventListener("submit", (e) => {
      if (!idInput || !idInput.value) {
        e.preventDefault();
        console.warn("Subscription product not wired — set it in Theme settings → Subscription.");
      }
    });
  }

  /* ---- Community carousel: randomize order each load, arrow scrolling --- */
  const rail = $("[data-qrail]");
  if (rail) {
    const cards = [...rail.children];
    for (let i = cards.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [cards[i], cards[j]] = [cards[j], cards[i]];
    }
    cards.forEach((c) => rail.appendChild(c)); // re-append in shuffled order
    const step = () => Math.max(rail.clientWidth * 0.8, 280);
    const prev = $("[data-qprev]"), next = $("[data-qnext]");
    prev && prev.addEventListener("click", () => rail.scrollBy({ left: -step(), behavior: "smooth" }));
    next && next.addEventListener("click", () => rail.scrollBy({ left: step(), behavior: "smooth" }));
  }

  /* ---- Subscribe page: nav Subscribe button stays put but muted (gray) above
     the fold, then turns accent once the buy-box scrolls out of view ---------- */
  const navCta = $(".nav__cta .btn--accent");
  const buyBox = $("#buy");
  if (navCta && buyBox && "IntersectionObserver" in window) {
    navCta.classList.add("nav-cta-soft");
    const navIO = new IntersectionObserver(
      ([e]) => navCta.classList.toggle("is-live", !e.isIntersecting),
      { rootMargin: "-72px 0px 0px 0px" }
    );
    navIO.observe(buyBox);
  }

  render();
})();
